import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Switch, Route, Redirect } from 'react-router-dom'
import Helmet from 'react-helmet'

import Placeholder from '../../../SPRINTA/atoms/PlaceHolder'
import { Container, Row, Col } from '../../../SPRINTA/atoms/Grid'

import * as user from '../../utils/user'
import Topbar from './Topbar'

import ConfigPage from './Pages/Config'
import Follow from './Pages/Follow'
import Events from './Pages/Events'
import Experiences from './Pages/Experiences'
import Inscriptions from './Pages/Inscriptions'
import Home from './Pages/Home'
import Challenges from './Pages/Challenges'
import { userChallenges } from '../../utils/challenge'

import T from '../../../SPRINTA/translate/T'

class Page extends Component {
  username = null
  loadedData = false

  state = {
    loading: true,
    userData: null,
    challenges: null
  }

  componentWillReceiveProps(nextProps) {
    if(this.username !== nextProps.match.params.username || nextProps.user.userData !== this.props.user.userData) {
      this.username = nextProps.match.params.username
      this.loadedData = false
      this.setState({
        loading: true
      })
    }

    if(nextProps.user.status === 'done' && !this.loadedData) {
      this.loadedData = true
      user.getProfile(this.username)
      .then(data => {
        console.log(data.errors)

        if(data.errors[0] && data.errors[0].type === 'not_found') {
          this.props.history.push('/404')
        }

        userChallenges(data.profile.id, { limit: 3 })
        .then(resp => {
          this.setState({
            challenges: resp.result
          })
        })
        
        this.setState({
          loading: false,
          userData: data
        })
      })
    }
  }

  handleUploaded(type, image) {
    let profile = this.state.userData.profile
    if(type === 'avatar')
      profile.avatarPath = image
    if(type === 'cover')
      profile.coverPath = image

    this.setState({
      userData: {
        ...this.state.userData,
        profile
      }
    })
  }

  handleFollowToggle( action ) {
    let following = action === 'unfollow' ? true : false
    let followers = this.state.userData.followSummary.followers
    this.setState({
        userData: {
            ...this.state.userData,
            followSummary: {
                ...this.state.userData.followSummary,
                iAmFollowing: following ? false : true,
                followers: !following ? followers + 1 : followers - 1
            }
        }
    })
  }

  render() {
    if(this.state.loading)
      return (
        <div>
          <Placeholder type='retangle' style={{
            height: '300px'
          }} />
          <Container>
            <Row>
              <Col size='12 7'>
                <Placeholder type='retangle' style={{
                  height: '300px'
                }} />
              </Col>

              <Col size='12 5'>
                <Placeholder type='retangle' style={{
                  height: '150px'
                }} />
              </Col>
            </Row>
          </Container>
        </div>
      )

      console.log(this.state)

    return (
      <div>
        <Helmet>
          <title>SPRINTA | {this.state.userData.profile.name}</title>
          <meta property="og:locale" content={T.getLanguage()}/>
          <meta property="og:url" content={`${window.USER_PROFILE}${this.state.userData.profile.username || this.state.userData.profile.token }/}`}/>
          <meta property="og:title" content={`${this.state.userData.profile.name} | SPRINTA`}/>
          <meta property="og:description" content={this.state.userData.profile.text}/>
          <meta property="og:image" content={this.state.userData.profile.avatarPath} />
        </Helmet>
{/* Topbar */}
        {/* <Topbar
          challenges={this.state.challenges}
          data={this.state.userData}
          userLink={this.props.match.params.username}
          page={this.props.match.params.page}
          handleUploaded={(type, image) => this.handleUploaded(type, image)}
          handleFollowToggle={action => this.handleFollowToggle(action)}
        /> */}

        <Switch>
          <Route exact path="/user/:user" render={context => (
            <Home userData={this.state.userData} {...context} />
          )} />

          <Route exact path="/user/:user/challenges" render={context => (
           <Challenges userData={this.state.userData} {...context} />
          )} />

          <Route exact path="/user/:user/(inscriptions|subscriptions)/:filter?" render={context => (
              <Inscriptions userData={this.state.userData} {...context} />
          )} />
          
          <Route exact path="/user/:user/events" render={context => (
            <Events username={context.match.params.user} />
          )} />
          
          <Route exact path="/user/:user/experiences" render={context => (
            <Experiences username={context.match.params.user} />
          )} />

          <Route exact path="/user/:user/followers" render={context => (
            <Follow type='followers' username={context.match.params.user} />
          )} />
          
          <Route exact path="/user/:user/following" render={context => (
            <Follow type='following' username={context.match.params.user} />
          )} />
          
          {this.state.userData.isMe && (
            <Route exact path="/user/:user/config" render={context => 
              <ConfigPage
                page='home'
                username={context.match.params.user} />
            } />
          )}
          {this.state.userData.isMe && (
              <Route exact path="/user/:user/config/:page" render={context => 
                <ConfigPage
                  page={context.match.params.page}
                  username={context.match.params.user} />
              } />            
          )}

          <Route render={() => {
            window.location.href = `/login?redirect_to=${window.location.href}`
          }}/>
        </Switch>
      </div>
    )
  }
}

const mapStateToProps = store => ({
  user: store.user
})
const mapDispatchToProps = {

}
export default connect( mapStateToProps, mapDispatchToProps )(Page)


// WEBPACK FOOTER //
// ./src/App/pages/Profile/index.js